<script lang="ts">
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';
    import { afterUpdate } from 'svelte';

    import IconDropdown from './Icons/IconDropdown.svelte';
    import { getWeekdayShort } from '../utilities/Weekdays';
    import { FriendlyDateGenerator } from '../utilities/FriendlyDateGenerator';
    import { clientSettings } from '../../stores/api';
    import { debug } from '../../stores/store';

    export let day: string;
    export let minDay: string | null = null;
    export let disabled: boolean = false;
    export let onChange: (day: string) => void = () => {};
    export let drops: string = 'down';
    export let showRelativeToday: boolean = false;
    export let valid: boolean = true;
    export let autoApply: boolean = true;

    let dateContainer: HTMLDivElement;
    let datePickerContainer: HTMLDivElement;
    let friendlyDate: FriendlyDateGenerator;

    // function displayOnlyDayAndMonth(date: string): string {
    //     if (date) {
    //         return date.split('-')[2] + '.' + date.split('-')[1];
    //     }
    //     return $_('date_option_not_set');
    // }

    afterUpdate(() => {
        let settings = {
            // alwaysShowCalendars: false,
            showCustomRangeLabel: false,
            singleDatePicker: true,
            autoApply: autoApply,
            drops,
            // parentElement: datePickerContainer,
            // minYear: 2023,
            // maxYear: parseInt(m().format('YYYY'), 10),
            startDate: day || new Date().toISOString().substring(0, 10),
            // endDate: day,
            // minDate: minDay,
            // maxDate: maxDate,
            locale: {
                format: 'YYYY-MM-DD',
                cancelLabel: $_('Cancel'),
                applyLabel: $_('Apply'),
                daysOfWeek: [$_('Sun'), $_('Mon'), $_('Tue'), $_('Wed'), $_('Thu'), $_('Fri'), $_('Sat')],
                monthNames: [
                    $_('January'),
                    $_('February'),
                    $_('March'),
                    $_('April'),
                    $_('May'),
                    $_('June'),
                    $_('July'),
                    $_('August'),
                    $_('September'),
                    $_('October'),
                    $_('November'),
                    $_('December'),
                ],
                firstDay: 1,
            },
            applyClass: 'date-range-button-apply',
            cancelClass: 'date-range-button-cancel',
        };
        if (minDay !== null) {
            settings['minDate'] = minDay;
        }
        // @ts-ignore daterangepicker is not recognized
        jQuery(dateContainer).daterangepicker(settings, function (start, end, label) {
            console.log(
                'daterangepicker, New date selected: ' +
                    start.format('YYYY-MM-DD') +
                    ' to ' +
                    end.format('YYYY-MM-DD') +
                    ' (predefined range: ' +
                    label +
                    ')'
            );
            // day = start.format('YYYY-MM-DD');
            // if (typeof onChange === 'function') onChange(day);
        });

        // @ts-ignore daterangepicker is not recognized
        jQuery(dateContainer).on('apply.daterangepicker', function (ev, picker) {
            ev.stopPropagation(); // not works
            console.log('apply.daterangepicker 2 ', picker.startDate.format('YYYY-MM-DD'));
            day = picker.startDate.format('YYYY-MM-DD');
            if (typeof onChange === 'function') onChange(day);
        });

        // @ts-ignore daterangepicker is not recognized
        // jQuery(dateContainer).on('cancel.daterangepicker', function (ev, picker) {
        //     console.log('cancel.daterangepicker', picker.startDate.format('YYYY-MM-DD'));
        // });

        // @ts-ignore jQuery is not recognized
        jQuery('.daterangepicker')
            .css('z-index', 20000000)
            .css('box-shadow', '-1px 11px 31px -10px rgba(0, 0, 0, 0.75)');
        // .on('click', function (event) {
        //     console.log('click', event);
        //     event.stopPropagation();
        // });
        // @ts-ignore jQuery is not recognized
        // jQuery('.daterangepicker .drp-calendar').on('click', function (event) {
        //     console.log('click, drp-calendar', event);
        //     event.stopPropagation();
        // });
    });

    friendlyDate = new FriendlyDateGenerator(day, showRelativeToday);

    $: {
        friendlyDate.set(day);
        friendlyDate.setShowRelativeToday(showRelativeToday);
        friendlyDate = friendlyDate;
        console.log(
            'friendlyDate.getRelativeTodayText()',
            day,
            friendlyDate.getRelativeTodayText()
        );
    }
</script>

<div
    class="select-day-container"
    class:disabled
    class:invalid-input={!valid}
    on:click|stopPropagation
>
    <div class="container" bind:this={dateContainer}>
        {#if showRelativeToday}
            {#if friendlyDate.getRelativeTodayText() !== ''}
                <span class="bold dont-break">{$_(friendlyDate.getRelativeTodayText())}</span>
            {:else}
                <span class="bold dont-break">{friendlyDate.getDayAndMonthNumeric()}</span>
            {/if}
        {:else}
            <span class="bold">{friendlyDate.getDayAndMonthNumeric()}</span>
        {/if}
        <div style="display: flex; flex-direction: row; align-items: center;">
            {#if friendlyDate.getRelativeTodayText() !== friendlyDate.getDayOfWeek()}
                <span class="lite">{day ? '(' + $_(getWeekdayShort(day)) + ')' : ''}</span>
            {:else if day === ''}
                <span class="lite italic dont-break">{$_('select_day')}</span>
            {/if}
            <IconDropdown scale={1} />
        </div>
    </div>
    <div class="" bind:this={datePickerContainer}></div>
</div>

<style>
    .select-day-container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-end;
        cursor: pointer;
        border-radius: 3px;
        padding: 0 3px;
    }
    .container {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        column-gap: 6px;
    }
    .bold {
        font-weight: 500;
    }
    .lite {
        font-weight: 300;
    }
    .disabled {
        opacity: 0.5;
        pointer-events: none;
    }
    .relative-day {
        font-size: 12px;
        margin-top: auto;
        padding-bottom: 5px;
        font-weight: 300;
    }
    .italic {
        font-style: italic;
    }
</style>
